import React from 'react';
import { ClockIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useFinanceSection } from '../../finance/section/finance-section-context';

// "Your First Stripe Payout" (Finance Overview v3, designer 2026-10-11): on
// Overview, Payouts and a payout's own page, full width. The API decides
// when (direct charges, went live under 30 days ago, no payout paid yet, not
// closed); the finance section reads it once per company, so closing it on
// one page closes it on all three, and the API keeps it closed on every
// device. The md's colours are the finance palette's notice tokens.
export const FIRST_PAYOUT_COPY = {
  title: 'Your First Stripe Payout',
  moved: "We've recently moved your payouts to Stripe. ",
  wait:
    "Your first payout typically takes around 7 days after your first payment through Stripe, but it may take up to 14 days due to Stripe's initial payout policy.",
  oneTime: 'This is a one-time waiting period.',
};

const FirstPayoutBanner = () => {
  const { firstPayoutNotice, dismissFirstPayoutNotice } = useFinanceSection();
  if (firstPayoutNotice !== 'legacy' && firstPayoutNotice !== 'new') return null;
  const body = (firstPayoutNotice === 'legacy' ? FIRST_PAYOUT_COPY.moved : '') + FIRST_PAYOUT_COPY.wait;
  return (
    <section className="flex items-start gap-3 rounded-[18px] bg-fin-notice px-4 py-3.5 font-inter tracking-normal">
      <ClockIcon className="mt-px h-5 w-5 flex-none stroke-2 text-fin-amber" aria-hidden="true" />
      <div className="flex min-w-0 flex-1 flex-col gap-[5px]">
        <h2 className="text-[15px] font-bold leading-[1.35] text-fin-notice-ink">{FIRST_PAYOUT_COPY.title}</h2>
        <p className="text-[14px] leading-[1.45] text-fin-notice-text [text-wrap:pretty]">{body}</p>
        <p className="text-[14px] leading-[1.45] text-fin-notice-text">{FIRST_PAYOUT_COPY.oneTime}</p>
      </div>
      <button
        type="button"
        aria-label="Dismiss"
        onClick={dismissFirstPayoutNotice}
        className="-mr-1.5 -mt-1.5 flex h-8 w-8 flex-none items-center justify-center rounded-lg text-fin-amber hover:bg-fin-amber/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-fin-amber"
      >
        <XMarkIcon className="h-[18px] w-[18px] stroke-[2.2]" aria-hidden="true" />
      </button>
    </section>
  );
};

export default FirstPayoutBanner;
